import React, { forwardRef } from 'react';
import { css } from '@linaria/core';
import { brand, theme } from '@terveystalo/design-system-theme';
import { focusVisible } from '../../css-utils/focus-visible';
import { classnames } from '../../utils';
const styles = [
    css `
    appearance: none;
    position: relative;
    width: ${theme.spacing['1_5']};
    height: ${theme.spacing['1_5']};

    background-color: ${brand.radio.color.default.background.onLight};

    border-width: ${theme.border.width.xs};
    border-radius: ${brand.radio.border.radius};
    border-color: ${brand.radio.color.default.border};

    transition-property: background-color, border-color;
    transition-duration: ${theme.animation.duration.default};

    &:checked {
      border-color: ${brand.radio.color.checked.border};
      background-color: ${brand.radio.color.checked.background};

      &::after {
        content: '';
        display: block;
        position: absolute;
        width: ${theme.spacing['0_5']};
        height: ${theme.spacing['0_5']};
        background-color: ${brand.radio.color.checked.content};
        border-radius: ${brand.radio.border.radius};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &:disabled {
      border-color: ${brand.radio.color.disabled.border};
      background-color: ${brand.radio.color.disabled.background};

      &:checked {
        background-color: ${brand.radio.color.disabled.checked.background};
      }
    }

    ${focusVisible(`
        outline: 0;
        box-shadow: 0 0 0 ${theme.border.width.xs} ${brand.radio.color.focus.outline.inner}, 0 0 0 ${theme.border.width.s} ${brand.radio.color.focus.outline.outer};
      `, `
        box-shadow: none;
      `)}
  `,
];
/**
 * Radio button component which extends the native radio input element.
 */
export const RadioButton = forwardRef(function RadioButton(props, ref) {
    const { className, grayBackground, ...rest } = props;
    return (React.createElement("input", { className: classnames(...styles, grayBackground &&
            css `
            background-color: ${brand.radio.color.default.background.onDark};
          `, className), type: "radio", ref: ref, ...rest }));
});


import "../../../css/atoms/RadioButton/RadioButton.css";
